import React from "react";

import styled from "styled-components/macro";

import FnrTypography from "FnrTypography";

import { useGetBackgroundColorData } from "../../../API/queryHooks";

import SearchBar from "./SearchBar";

const NotesHeader = ({
  isLoggedIn,
  isMobile,
  searchTerm,
  setSearchTerm,
  error,
  hasNotes,
}) => {
  const hasNoInitialNotes = searchTerm === "" && !hasNotes;
  const showSearchBar = isLoggedIn && !error && !hasNoInitialNotes;
  const { textColor } = useGetBackgroundColorData();

  return (
    <Header $isMobile={isMobile}>
      <FnrTypography
        type="header"
        fontWeight={600}
        fontSize="decorative3"
        color={textColor}
      >
        {isLoggedIn ? "My Notes" : "Notes"}
      </FnrTypography>

      {showSearchBar && (
        <SearchBar
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          isMobile={isMobile}
        />
      )}
    </Header>
  );
};

const Header = styled.div`
  display: flex;
  flex-direction: ${({ $isMobile }) => ($isMobile ? "column" : "row")};
  justify-content: space-between;
  align-items: ${({ $isMobile }) => ($isMobile ? "flex-start" : "center")};
  margin-top: ${({ $isMobile }) => ($isMobile ? "0" : "50px")};
  margin-bottom: ${({ $isMobile }) => ($isMobile ? "25px" : "50px")};
  margin-left: ${({ $isMobile }) => ($isMobile ? "18px" : "20px")};
  ${({ $isMobile }) =>
    $isMobile &&
    `
    gap: 15px;
  `}
`;

export default NotesHeader;
